// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list_menu":"list_menu-2nIz8qdl","morehNew":"morehNew-15fz-OMJ","more":"more-1OlyWcyU"};